/**
 * 開発時（localhost）のみ: テンプレート変更による full-reload 後もスクロール位置を復元
 * PC は .l-container (fixed / overflow-y: auto) がスクロール要素のため scrollTop で制御
 */
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
if (hostname === 'localhost' || hostname === '127.0.0.1') {
	(function () {
		const key = 'vite-dev-scroll';
		const pathname = window.location.pathname;
		try {
			const getEl = function () {
				return document.querySelector('.l-container') || document.scrollingElement || document.documentElement;
			};
			const save = function () {
				const el = getEl();
				sessionStorage.setItem(key, JSON.stringify({ pathname, scrollTop: el.scrollTop }));
			};
			const restore = function () {
				const saved = sessionStorage.getItem(key);
				if (!saved) return;
				const data = JSON.parse(saved);
				if (data.pathname !== pathname || typeof data.scrollTop !== 'number') return;
				const el = getEl();
				el.scrollTop = data.scrollTop;
			};
			window.addEventListener('load', restore);
			let tid;
			const onScroll = function () {
				clearTimeout(tid);
				tid = setTimeout(save, 150);
			};
			window.addEventListener('load', function () {
				const el = getEl();
				el.addEventListener('scroll', onScroll, { passive: true });
			});
			window.addEventListener('beforeunload', save);
			window.addEventListener('pagehide', save);
		} catch (e) {}
	})();
}
